import { ActiveBundlePageTypeKeys } from '@/store';
import { bundleTypeMap } from '../constants';
import { api } from '../core';

interface CreateChronologyEntryResponse {
  entryId: string;
}

interface CreateChronologyEntryProps {
  abortController?: AbortController;
  caseId: string;
  bundlePageType: ActiveBundlePageTypeKeys;
  chronologyEntry: CreateChronologyEntry;
}
export interface CreateChronologyEntry {
  date: string; // '2025-01-01';
  time: string | null; //"00:00:00" or null
  providerId: string | null;
  verbatimExtract: string;
  comment: string;
  bundlePageNumbers: number[];
}
const chronologyEntryCreateApi = api.injectEndpoints({
  endpoints: (builder) => ({
    createChronologyEntry: builder.query<CreateChronologyEntryResponse, CreateChronologyEntryProps>({
      query: ({
        abortController = new AbortController(),
        caseId,
        bundlePageType,
        chronologyEntry: { date, time, providerId, verbatimExtract, comment, bundlePageNumbers }
      }: CreateChronologyEntryProps) => ({
        url: 'chronology/entry/create',
        method: 'POST',
        body: {
          case_id: caseId,
          bundle_type_to_add_from: bundleTypeMap[bundlePageType],
          chronology_entry: {
            date,
            time,
            provider_id: providerId,
            verbatim_extract: verbatimExtract,
            comment,
            bundle_page_numbers: bundlePageNumbers
          }
        },
        signal: abortController.signal
      }),
      async onQueryStarted(_, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (error) {
          if (error instanceof Error && error.name === 'AbortError') {
            console.log('Request was aborted');
          } else {
            console.error('Error in createChronologyEntry in onQueryStarted:', error);
          }
        }
      },
      extraOptions: { maxRetries: 0 }
    })
  })
});

/**
 * Export hooks for usage in functional components, which are
 * auto-generated based on the defined endpoints
 */
export const { useLazyCreateChronologyEntryQuery } = chronologyEntryCreateApi;
